<nav class="in-play-tab" mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (item of navItems; track item) {
    <a
      mat-tab-link
      [routerLink]="item?.path"
      routerLinkActive
      #rla="routerLinkActive"
      [active]="rla?.isActive"
    >
      {{ item.label | translate }}
    </a>
  }
</nav>
<mat-tab-nav-panel #tabPanel >
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
